// Saving a file the API produced.
//
// Every document the platform hands a person is rendered server-side — Word for
// generated documents (in the organisation's own template or brand colours),
// PDF for reports, CSV or XLSX for data. The browser's job is only to save the
// bytes under the right name; it never composes a document itself, and it never
// writes markdown to disk.

export function saveBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/** Strips what Windows and macOS refuse in a file name. */
export function fileNameSafe(input: string, fallback = "Document"): string {
  return (input || fallback)
    .replace(/[\\/:*?"<>|\r\n]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 120) || fallback;
}
